import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.707 15.293a1 1 0 0 1 0 1.414L17.414 19l2.293 2.293a1 1 0 0 1-1.414 1.414L16 20.414l-2.293 2.293a1 1 0 0 1-1.414-1.414L14.586 19l-2.293-2.293a1 1 0 0 1 1.414-1.414L16 17.586l2.293-2.293a1 1 0 0 1 1.414 0"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 3a1 1 0 1 0-2 0v1H11V3a1 1 0 1 0-2 0v1H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3zm3 3h-3v1a1 1 0 1 1-2 0V6H11v1a1 1 0 1 1-2 0V6H6v4h20zM6 12h20v14H6z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconCalendarX = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCalendarX);
export default Memo;
